export default __webpack_public_path__ + "ba20ef90e1469dd5094a03b39b9a88e6.svg";